import React from "react";

export default function BusinessCompanyIcon() {
  return (
    <svg
      width="24px"
      height="26px"
      viewBox="0 0 27 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round">
        <g
          id="Sidemenu-/-Item-Unselected"
          transform="translate(-19.000000, -6.000000)" // Adjust transform to center the icon if needed, or draw directly
          stroke="#FFFFFF"
          strokeWidth="1.5">
          <g id="Icons-/-Line-/-Business" transform="translate(20.000000, 7.435484)">
            {/* Building Body */}
            {/* M = moveto, L = lineto, Z = closepath */}
            <path d="M 5 24 L 5 9 L 22 9 L 22 24 Z" id="BuildingBody"></path>

            {/* Roof - simple triangle */}
            <path d="M 3 9 L 13.5 3 L 24 9 Z" id="Roof"></path>

            {/* Windows */}
            {/* Window 1 */}
            <path d="M 8 13 L 8 16 L 11 16 L 11 13 Z" id="Window1"></path>
            {/* Window 2 */}
            <path d="M 16 13 L 16 16 L 19 16 L 19 13 Z" id="Window2"></path>
            {/* Window 3 */}
            <path d="M 8 19 L 8 22 L 11 22 L 11 19 Z" id="Window3"></path>
            {/* Window 4 */}
            <path d="M 16 19 L 16 22 L 19 22 L 19 19 Z" id="Window4"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
